//#region src/log-levels.ts
/**
* The shared log-level vocabulary (§12.3a, **R-64 / R-57**).
*
* ⛔ PURE strings + a Set. Zero Nest, zero zod — so **R-37.1 is not re-opened**:
* this is not the `app-scope.ts` move that ruling withdrew. `assertAllowedLevel`
* and every other `assert*` STAY in `app-scope.ts` with their Nest throws, and
* that file re-exports all three symbols below (the live R-27 shim pattern), so
* no consumer changes.
*
* ⛔ A **do-not-merge-these** rule applies to the Site-Admin UI's
* identically-named twin (`logs-format.ts:80`), whose mapping is strictly larger
* (`err`/`fatal`/`critical`→`error`) and drives `levelColorClass`: merging them
* would silently stop rendering `fatal` and `critical` as errors (R-64 F-4).
*/
/**
* Canonical log-level allowlist (compared case-insensitively by the caller).
*
* ⭐ `UNKNOWN` is a REAL, QUERYABLE LEVEL — not a placeholder. Loki emits the
* literal string `unknown` as a `detected_level` value for lines it cannot
* classify (measured on the live DP Loki, 2026-08-03: 103 of 300 streams).
*/
const ALLOWED_LEVELS = /* @__PURE__ */ new Set([
	"TRACE",
	"DEBUG",
	"INFO",
	"WARN",
	"WARNING",
	"ERROR",
	"FATAL",
	"UNKNOWN"
]);
/** Lowercase, with the `WARNING` synonym folded to `warn` (Loki's own token). */
function normalizeLevel(value) {
	const lower = value.toLowerCase();
	return lower === "warning" ? "warn" : lower;
}
/**
* ⭐ DERIVED, never hand-written — the literal R-57 was minted to remove.
* `WARN` and `WARNING` both normalize to `warn`, so this Set has **7** members
* where `ALLOWED_LEVELS` has 8. That difference is the whole point (R-41.5).
*/
const NORMALIZED_LOG_LEVELS = new Set([...ALLOWED_LEVELS].map(normalizeLevel));
//#endregion
export { ALLOWED_LEVELS, NORMALIZED_LOG_LEVELS, normalizeLevel };

//# sourceMappingURL=log-levels.js.map